import { PlaylistItem, PlaylistSource } from '@/interfaces/player-config.interface';

export type QualitySelector = Pick<PlaylistSource, 'label' | 'bitrate' | 'hight'>;

function setSelectedSourceByQuality(playlistItem: PlaylistItem, quality: QualitySelector) {
  let source: PlaylistSource | undefined = undefined;
  source = playlistItem.sources.find((_source) => _source.label === quality.label);

  if (!source) {
    const sourcesWithSameHight = playlistItem.sources.filter((_source) => _source.hight === quality.hight);
    if (sourcesWithSameHight.length > 1) {
      source = sourcesWithSameHight.find((_source) => _source.bitrate === quality.bitrate);
    } else {
      source = sourcesWithSameHight[0];
    }
  }
  if (source) {
    playlistItem.sources.forEach((_source) => (_source.selected = false));
    source.selected = true;
  }
}

export function setSelectedSourcesByQuality(playlist: any, playlistConfig: PlaylistItem[], quality: QualitySelector) {
  const index = playlist.currentIndex();

  playlistConfig.forEach((playlistItem) => setSelectedSourceByQuality(playlistItem, quality));
  // reinitialize the playlist
  playlist(playlistConfig);
  playlist.currentItem(index);

  setTimeout(() => {
    var elements = document.querySelectorAll('.vjs-quality-selector');
    if (elements) {
      elements.forEach(function (element) {
        element.classList.remove('vjs-hidden');
      });
    }
  }, 100);
}
